import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import React from 'react';

import styles from './Slider.module.css';

import type { ReactElement } from 'react';

const ModifiedSlider = styled(Slider)(() => ({
  color: '#227979',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#D3E4E4',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(167,201,201,0.5)',
    },
    '&:focus, &:active': {
      boxShadow: '0 0 0 8px rgba(122,175,175,0.5)',
    },
    '& .mp-bar': {
      height: 9,
      width: 1,
      backgroundColor: '#227979',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  '& .MuiSlider-track': {
    color: '#7AAFAF',
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: '#EAEAEA',
    opacity: 1,
    height: 3,
  },
}));

type MPThumbComponentProps = React.HTMLAttributes<unknown>;

const MPThumbComponent = (props: MPThumbComponentProps): ReactElement => {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="mp-bar" />
      <span className="mp-bar" />
    </SliderThumb>
  );
};

export type MPSliderProps = {
  description: string;
  handleChange: (event: Event, newValue: number | number[]) => void;
  label?: string;
  max: number;
  maxAriaLabel?: string;
  min?: number;
  minAriaLabel?: string;
  value: number[];
};

export const MPSlider = ({
  description,
  handleChange,
  label = 'Price',
  max,
  maxAriaLabel = 'Maximum price',
  min = 0,
  minAriaLabel = 'Minimum price',
  value,
}: MPSliderProps): ReactElement => (
  <div className={styles.root}>
    <label className={styles.label}>{label}</label>
    <p>{description}</p>
    <div className={styles.slider}>
      <ModifiedSlider
        defaultValue={[min, max]}
        getAriaLabel={(index: number): string => (index === 0 ? minAriaLabel : maxAriaLabel)}
        max={max}
        min={min}
        onChange={handleChange}
        slots={{ thumb: MPThumbComponent }}
        sx={{ flexGrow: 1 }}
        value={value}
        valueLabelDisplay="auto"
      />
    </div>
  </div>
);
